import { registerPlugin } from '@capacitor/core';

import type { SignInWithApplePlugin } from './definitions';
import { CAPACITOR_SIGN_IN_WITH_APPLE_PLUGIN_NAME } from '../pluginConstants';

const SignInWithApple = registerPlugin<SignInWithApplePlugin>(CAPACITOR_SIGN_IN_WITH_APPLE_PLUGIN_NAME);

export * from './definitions';
export { SignInWithApple };
